
<script>
export default {
  name: "ErrorMessage",
  props: {
    value: {
      type: Object,
      required: true,
    },
    goodDelay: {
      type: Number,
      default: null,
    },
  },
  computed: {
    computedClass() {
      if (this.value.status && Math.floor(this.value.status / 100) === 2) {
        return "good";
      }
      if (this.value.status && Math.floor(this.value.status / 100) === 3) {
        return "info";
      }
      return "alert";
    },
  },
  watch: {
    value() {
      this.timeout();
    },
  },
  mounted() {
    this.timeout();
  },
  methods: {
    timeout() {
      if (this.goodDelay !== null && this.computedClass === "good") {
        setTimeout(() => {
          this.$emit("input", this.value.id);
        }, this.goodDelay);
      }
    },
    removeError() {
      this.$emit("input", this.value.id);
    },
  },
};
</script>

<template>
  <div :class="computedClass" class="flex flex-row align-center justify-between p-4 mb-4 rounded-sm border border-solid"
    data-cy="errorMessage">
    <span class="pt-2 font-bold">{{ $t(value.message) }}</span>
    <button data-cy="removeError" class="p-2" @click="removeError()">
      <font-awesome-icon icon="times" />
    </button>
  </div>
</template>

<style scoped>
.alert {
  @apply bg-red-100 text-red-700 border border-solid border-red-300;
}

.info {
  @apply bg-blue-100 text-blue-700 border border-solid border-blue-300;
}

.good {
  @apply bg-green-100 text-green-700 border border-solid border-green-300;
}
</style>
